import { render, staticRenderFns } from "./moduleList.vue?vue&type=template&id=81b4fbc6&scoped=true"
import script from "./moduleList.vue?vue&type=script&lang=js"
export * from "./moduleList.vue?vue&type=script&lang=js"
import style0 from "./moduleList.vue?vue&type=style&index=0&id=81b4fbc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../Com.GamerSky.App.GameTools/GamerSky.recordInquiry/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b4fbc6",
  null
  
)

export default component.exports